export default {
  message: {
    "error": "Произошла ошибка!",
    "Sorrysomeerrorsoccurred": "Извините, произошли некоторые ошибки",
    "quit": "Выйти",
    "language": "Язык",
    "Youcanchangethelanguagehere": "Вы можете изменить язык здесь!",
    "current": "Текущий",
    "home": "Главная",
    "friends": "Друзья",
    "wallet": "Кошелек",
    "aboutus": "О нас",
    "Sharewithfriends": "Поделитесь с друзьями",
    "copyFailure": "Ошибка копирования",
    "copySuccess": "Успешное копирование",
    "Claimreward": "Получить награду",
    "DailyLogin": "Ежедневный вход",
    "noInvitationsYet": "Пока нет приглашений",
    "LoadMore": "Загрузить больше",
    "WatchAD": "Посмотреть рекламу",
    "continue": "Продолжить",
    "Congratulations": "Поздравляем",
    "MyFriends": "Мои Друзья",
    "Invitefriends": "Пригласить друзей",
    "Invitepremiumfriends": "Пригласить премиум-друзей",
    "DailyTasks": "Ежедневные задачи",
    "inviteDesc": "+{num} ${name} за каждого приглашенного друга",
    "DailyTasksDesc": "Выполняйте задания, чтобы получить больше ${name}",
    "SponsorsandPartners": "Спонсоры и Партнеры",
    "Receivingwallet": "Получающий кошелек",
    "Enterwalletaddress": "Введите адрес кошелька {name}",
    "Claim": "Получить",
    "Booster": "Увеличитель",
    "RentPeriod": "Период аренды",
    "days30": "30 дней",
    "days": "дней",
    "Dailyprofit": "Ежедневная прибыль",
    "Totalprofit": "Общая прибыль",
    "Quantity": "Количество",
    "RentPrice": "Цена аренды",
    "RentMiner": "Арендовать майнер",
    "Insufficient": "Недостаточно ${name}",
    "InsufficientMsg": "Необходимо {num} ${name1}, пригласите друзей или выполните задачи, чтобы заработать больше ${name2}.",
    "Settings": "Настройки",
    "copyid": "Скопировать ID",
    "UpgradeSuccessfully": "Успешное обновление",
    "Name": "Имя",
    "userinfo": "Информация о пользователе",
    "disconnect": "Отключиться",
    "Startmining": "Начать добычу",
    "Welcome": "Добро пожаловать в {name}",
    "Withdrawal": "Вывод",
    "Minimumamount": "Минимальная сумма",
    "Networkfee": "Сетевая комиссия",
    "Enteramount": "Введите сумму",
    "Submit": "Отправить",
    "MinimumTip": "Сумма вывода слишком мала. Минимальная сумма вывода: {num}",
    "MaximumTip": "Недостаточная сумма, максимальная сумма, которую вы можете вывести: {num}",
    "SubmittedTip": "Отправлено, ожидается обработка в течение 30-60 рабочих дней",
    "WithdrawStatus": "Статус",
    "Submissiontime": "Время подачи",
    "WithdrawAwaitTip": "* Ожидается, что это займет 30-60 рабочих дней. Приглашение большего количества друзей может ускорить процесс рассмотрения.",
    "Processing": "Обработка",
    "Amount": "Сумма",
    "Numberoffriends": "Количество друзей: {now}/{limit}",
    "InviteTip": "Чтобы сделать первый вывод, вам нужно пригласить {limit} друзей присоединиться к приложению для майнинга.",
    "openonphone": "Откройте эту ссылку на своем телефоне.",
    "claimTip": "Сумма для получения слишком мала. Минимальная сумма для получения: {num}",
    "WalletBalance": "Баланс кошелька",
    "Withdraw": "Вывод",
    "SetWalletAddress": "Установить адрес кошелька",
    "WithdrawalRecord": "Запись о выводе",
    "Norecords": "Нет записей",
    "Whatis": "Что такое {name}?",
    "All": "Все",
    "save": "Сохранить",
    "successWithdrawal": "Вывод был получен {num}",
    "secondsago": "{time} секунд назад",
    "Loading": "Загрузка...",
    "PaymentConfirming": "Проверка статуса транзакции...",
    "Check": "Проверить",
    "CheckFail": "Транзакция не выполнена. Пожалуйста, проверьте снова через 5 секунд.",
    "Addname": "Добавьте '{name}' к своему имени",
    "Restattcheck": "Перезапустите приложение, чтобы проверить",
    "Copyname": "Скопировать '{name}'",
    "SubmissionFailed": "Отправка не удалась, пожалуйста, попробуйте позже",
    "WithdrawalReview": "Рассмотрение вывода",
    "WebWithdrawAwaitTip": "* Ожидается, что это займет 24-48 часов. Приглашение большего количества друзей может ускорить процесс рассмотрения.",
    "Success": "Успех",
    "Rejection": "Отказ",
    "WebSubmittedTip": "Отправлено, ожидается обработка в течение 24-48 часов",
    "shop": "Магазин",
    "topurchase": "Перейти в магазин для покупки",
    "shopDesc": "Ограниченное количество — успейте получить свое, пока оно не исчезло!",
    "claim": "Получить",
    "payment_success": "Оплата прошла успешно",
    "payment_failed": "Ошибка оплаты",
    "payment_cancelled": "Оплата отменена",
    "opening_payment": "Открытие платежа...",
    "payment_status": "Статус платежа",
    "create_order_failed": "Не удалось создать заказ",
    "creating_ton_order": "Создание заказа TON...",
    "next_step": "Следующий шаг",
    "use_ton_payment": "Используйте платеж TON",
    "start_transaction": "Начать транзакцию",
    "connect_wallet": "Подключить кошелек",
    "address": "Адрес",
    "amount_ton": "Сумма TON",
    "copy": "Копировать",
    "amount": "Сумма",
    "wallet_address": "Адрес кошелька",
    "comment_memo": "Комментарий",
    "you_can_choose_to_connect_wallet_to_pay": "Вы можете выбрать подключение кошелька для оплаты",
    "or_manually_transfer_to_the_above_address": "Или вручную перевести на указанный выше адрес (учтите, что сумма и комментарий должны полностью совпадать)",
    "transaction_success": "Успех транзакции",
    "transaction_failed": "Не удалось осуществить транзакцию",
    "transaction_error": "Ошибка транзакции",
    "transaction_status": "Статус транзакции",
    "transaction_id": "ID транзакции",
    "transaction_amount": "Сумма транзакции",
    "transaction_status_desc": "Описание статуса транзакции",
    "payment_status_tip": "Пожалуйста, подождите, пока платеж не будет подтвержден",
    "select_payment_method": "Выберите способ оплаты",
    "total_amount": "Общая сумма",
    "creating_order": "Создание заказа...",
    "order_created": "Заказ создан",
    "order_status": "Статус заказа",
    "Applyforwithdrawal": "Подать заявку на вывод",
    "Withdrawalunlock": "Разблокировка вывода",
    "WithdrawalunlockTip": "Вам нужно {num} приглашенных друзей, чтобы выполнить задания/привязать кошельки для разблокировки вывода",
    "Close": "Закрыть",
    "Delivering": "Доставка",
    "Duetothelargenumber": "Из-за большого количества получателей, ваш airdrop ожидается в течение 15-20 рабочих дней",
    "select_network": "Выберите сеть",
    "confirm": "подтвердить",
    "switching_network": "Переключение сети...",
    "network_switched": "Сеть переключена",
    "use_usdt_payment": "Используйте платеж USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Вручную переведите на указанный выше адрес (обратите внимание, что сумма и адрес должны быть точно такими же)",
    "chain_type": "Сеть",
    "check_transaction_status": "Проверьте статус транзакции",
    "transaction_wait": "Транзакция обрабатывается. Вы можете выйти из приложения. Сообщение уведомит вас, когда она будет завершена.",
    "twa_pay_tip_with_memo": "Пожалуйста, убедитесь, что адрес, сумма и примечание соответствуют для перевода.",
    "twa_pay_tip": "Пожалуйста, убедитесь, что адрес и сумма правильные для перевода.",
    "creating_usdt_order": "Создание заказа USDT...",
    "affiliate_programs": "Партнерские программы",
    "affiliate_programs_description": "Пригласите друзей присоединиться к приложению для майнинга и получайте вознаграждения.",
    "commission_details": "Детали комиссии",
    "no_commission_records": "Нет записей о комиссиях",
    "commission_list": "Список комиссий",
    "input_amount": "Введите сумму",
    "max": "Макс",
    "commission_input_amount": "Введите сумму комиссии",
    "min_commission": "Минимальная сумма для вывода составляет {num}",
    "WithdrawalSuccess": "Вывод успешен",
    "WithdrawalFailed": "Вывод не удался",
    "WithdrawalProcessing": "Обработка вывода",
    "award": "Награда",
    "level": "Уровень",
    "Share_to_group": "Поделиться в группе",
    "Exchange": "Обмен",
    "balance_not_enough": "Недостаточно средств, вы можете обменять только {num} {coin}",
    "exchange_fail": "Ошибка обмена",
    "exchange_success": "Обмен успешно завершён",
    "you_will_receive": "Вы получите",
    "ShareToGroups": "Поделиться в группах",
    "Numberofgroups": "Количество групп: {now}/{limit}",
    "Confirm": "Подтвердить",
    "ShareToGroupsDesc": "Поделитесь в группах, чтобы получить больше {name}",
    "TokenAddress": "Пожалуйста, введите данные для вывода, такие как ID обмена или адрес USDT",
    "CashAddress": "Пожалуйста, введите данные для вывода, такие как номер банковской карты или адрес USDT",
    "Cancel": "Отменить",
    "min_withdrawal_amount": "Минимальная сумма вывода составляет {num} {coin}",
    "max_withdrawal_amount": "Максимальная сумма вывода составляет {num} {coin}",
    "withdrawal_failed": "Ошибка вывода",
    "withdrawal_success": "Вывод средств успешен",
    "PayNow": "Оплатить сейчас",
    "PaySkip": "Заплатите {num} для мгновенного разблокирования вывода",
    "NumberofGroups": "Количество групп: {now}/{limit}",
    "SendMessage": "Отправить сообщение",
    "NumberofShares": "Количество акций: {now}/{limit}",
    "NumberofTasks": "Количество заданий: {now}/{limit}",
    "CompleteTask": "Завершить задание",
    "PleaseEnterValidAmount": "Пожалуйста, введите действительную сумму",
    "PleaseEnterValidEmail": "Пожалуйста, введите действительный адрес электронной почты",
    "Feedback": "Обратная связь",
    "Inputfeedbackcontent": "Введите содержимое обратной связи",
    "Submitfeedback": "Отправить отзыв",
    "Pleaseenteravalidemailaddress": "Пожалуйста, введите действительный адрес электронной почты",
    "Pleaseenteryouremailaddress": "Пожалуйста, введите ваш адрес электронной почты",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Вы уже отправили отзыв сегодня, пожалуйста, вернитесь завтра",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Обратная связь успешно отправлена, спасибо за ваш ценный отзыв",
    "Feedback_submission_failed_please_retry": "Не удалось отправить отзыв, пожалуйста, попробуйте еще раз",
    "ContactUs": "Связаться с нами",
    "XRPAddress": "Пожалуйста, введите активированный адрес кошелька XRP (включая MEMO), иначе вы не сможете вывести деньги.",
    "Accelerated": "Ускоренные",
    "Accelerated_withdrawals_success": "Ускоренные снятия успешно",
    "login": "Вход",
    "register": "Регистрация",
    "login_with_google": "Войти с помощью Google",
    "or": "ИЛИ",
    "email": "Электронная почта",
    "password": "Пароль",
    "no_account": "Нет аккаунта",
    "click_to_go": "Нажмите, чтобы",
    "have_account": "Уже есть аккаунт",
    "go_to": "Перейти к",
    "invite_code": "Пригласительный код",
    "optional": "Необязательно",
    "google_login_not_ready": "Вход с Google еще не готов, пожалуйста, попробуйте позже",
    "password_too_long": "Пароль слишком длинный",
    "weak": "Слабый",
    "medium": "Средний",
    "strong": "Сильный",
    "login_success": "Вход выполнен успешно",
    "login_failed": "Ошибка входа",
    "please_input_email": "Пожалуйста, введите вашу электронную почту",
    "invalid_email": "Неверный формат электронной почты",
    "please_input_password": "Пожалуйста, введите ваш пароль",
    "password_length_6_to_16": "Пароль должен содержать от 6 до 16 символов",
    "account_or_password_error": "Ошибка аккаунта или пароля",
    "register_success": "Регистрация прошла успешно",
    "register_failed": "Ошибка регистрации",
    "save_error": "Ошибка сохранения, пожалуйста, попробуйте позже",
    "ShareToFriends": "Поделитесь с друзьями",
    "login_first": "Пожалуйста, сначала войдите в систему",
    "WalletBscError": "❌ Неверный адрес кошелька BNB Chain.",
    "DownloadWallet": "Скачать кошелек",
    "AddToHomeScreen": "Добавить {appName} на главный экран",
    "TapShareInToolbar": "Нажмите на панели инструментов",
    "SelectAddToHomeScreen": "Выберите добавить на главный экран",
    "OpenToolbar": "Открыть панель инструментов",
    "ClaimFailed": "Не удалось получить, пожалуйста, попробуйте позже",
    "guest_login": "Гостевой вход",
    "please_input_phone": "Пожалуйста, введите ваш номер телефона",
    "email_error_1": "Пожалуйста, введите ваш email",
    "email_error_2": "Пожалуйста, введите действительный адрес email",
    "email_error_3": "Гостевой email не допускается, пожалуйста, используйте реальный email",
    "phone": "Телефон",
    "phone_error_1": "Пожалуйста, введите ваш номер телефона",
    "phone_error_2": "Пожалуйста, введите действительный номер телефона",
    "update_info": "Обновить информацию",
    "update_success": "Обновление прошло успешно",
    "update_failed": "Не удалось обновить, пожалуйста, попробуйте позже",
    "cancel": "Отменить",
    "guest_credentials_title": "Информация об аккаунте",
    "guest_credentials_warning": "Пожалуйста, сделайте скриншот, чтобы сохранить ваш аккаунт и пароль. В случае потери ваши earnings не могут быть восстановлены!",
    "i_have_saved": "Я сохранил",
    "account": "Аккаунт",
    "view_credentials": "Просмотр учетных данных",
    "miner_max_reached": "Вы достигли максимального количества этого майнера"
}};